import { ref, watchEffect, onUnmounted } from '@vue/composition-api';
const largeMiniBannerCom = ref<any>(null);

const touchPosition = {
  posX: 0,
  posY: 0,
};
  /** 滑动距离阈值 */
const MoveYDistance = 20;
const MoveXDistance = 100;
const scrollEventHandler = function (e, handleScrollLong: Function) {
  switch (e.type) {
    case 'touchstart':
      // 记住滑动起始位子
      Object.assign(touchPosition, {
        // @ts-ignore
        posX: e.touches[0].clientX,
        // @ts-ignore
        posY: e.touches[0].clientY,
      });
      break;
    case 'touchmove':
      // @ts-ignore
      if (e.changedTouches[0].clientY < touchPosition.posY) {
        e.preventDefault();
      }
      break;
    case 'touchend':
      // 滑动超过一定有效距离才展示详细资料
      if (
      // @ts-ignore
        touchPosition.posY - e.changedTouches[0].clientY
      > MoveYDistance
    // @ts-ignore
    && Math.abs(e.changedTouches[0].clientX - touchPosition.posX)
      < MoveXDistance
      ) {
        handleScrollLong();
      }
      break;
  }
};
export function useLargeBannerScroll() {
  function cancelScrollEvent() {
    if (largeMiniBannerCom.value) {
      ['touchstart', 'touchmove', 'touchend'].forEach((key) => {
        largeMiniBannerCom.value.removeEventListener(key, scrollEventHandler);
      });
    }
  };
  onUnmounted(() => {
    cancelScrollEvent();
  });
  return {
    cancelScrollEvent,
    initScrollEvent(handleScrollLong: Function) {
      watchEffect(() => {
        if (largeMiniBannerCom.value) {
          ['touchstart', 'touchmove', 'touchend'].forEach((key) => {
            largeMiniBannerCom.value.addEventListener(key, (e) => {
              scrollEventHandler(e, handleScrollLong);
            });
          });
        }
      });
    },
    largeMiniBannerCom,
  };
}
